import React from 'react';
import { Box, Flex, Image, Link, Text } from '@chakra-ui/react';
import { Link as ReactLink } from 'react-router-dom';
import { containerMaxWXl } from '../ContentContainer/contentContainer';
import { isLauncher } from '../../utils/launcher';
import Vendor from '../../vendor.config';
import { Color } from 'src/theme/color';

const policies = [
	{
		name: 'Terms & conditions',
		url: 'https://cdn.hashup.it/legal-packages/GameXplorer_TermsAndConditions.pdf',
	},
	{
		name: 'Privacy Policy',
		url: 'https://cdn.hashup.it/legal-packages/GameContract_DataProtectionPolicy.pdf',
	},
];

export const Copyright = () => {
	return (
		<Flex
			maxW={containerMaxWXl}
			w={{ base: 'auto', md: '100%' }}
			mb={{ base: '15px', md: 0 }}
			display={{ base: 'block', hashup: `${isLauncher() ? 'none' : 'block'}`, xl: 'block' }}
		>
			<Flex
				mt="45px"
				w="100%"
				p="37px 0"
				display={{ base: ' none', md: 'flex' }}
				justifyContent="space-between"
				alignItems="center"
			>
				<Text
					fontSize="12px"
					color="#8A8F98"
				>
					Copyright © {new Date().getFullYear()} by HashUp All Rights Reserved.
				</Text>
				<Flex>
					<Flex
						alignItems="center"
						w="100%"
						justifyContent="center"
					>
						<Flex
							filter="grayscale(1)"
							alignItems="center"
							as={ReactLink}
							to="/"
						>
							<Image
								maxH="15px"
								src="/icons/hash_logo.svg"
							/>
							<Text
								ml="6px"
								mr="25px"
								fontWeight="800"
								lineHeight="38px"
								fontSize="14px"
							>
								ODL
							</Text>
						</Flex>
						<Flex
							fontSize="12px"
							color="#8A8F98"
							gridGap="15px"
							justifyContent="space-between"
						>
							{policies.map(({ url, name }) => (
								<Link
									key={`cp_${url}_${name}`}
									target="_blank"
									href={url}
									cursor="pointer"
								>
									{name}
								</Link>
							))}
						</Flex>
					</Flex>
				</Flex>
			</Flex>
			<Box
				textAlign="center"
				fontSize="14px"
				color="#8A8F98"
				fontWeight="400"
				display={{ base: ' block', md: 'none' }}
			>
				<Flex
					mb="15px"
					flexDirection="column"
					gridGap="10px"
					fontSize="12px"
					fontWeight="400"
					textAlign="center"
					p="10px 0"
					color="white"
				>
					{policies.map(policy => (
						<Link
							key={`cp_${policy.url}_${policy.name}`}
							target="_blank"
							href={policy.url}
						>
							{policy.name}
						</Link>
					))}
				</Flex>
				<Flex mb="5px">
					Copyright © {new Date().getFullYear()} by{' '}
					<Text
						m="0 5px"
						color={Color.ACTION}
					>
						HashUp
					</Text>
				</Flex>
				All Rights Reserved.
			</Box>
		</Flex>
	);
};
